import React from "react";
import PropTypes from "prop-types";
import produce from "immer";
import {
  findKey,
  flatten,
  includes,
  map,
  keys,
  isUndefined,
  omit,
  find,
} from "lodash";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// import Grid from "@material-ui/core/Grid";
// core components
import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "../../material-dashboard/components/Grid/GridItem.jsx";
import Button from "../../material-dashboard/components/CustomButtons/Button.jsx";
import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import performanceAnxietyInitial from "../../../../../medical/performanceAnxietyInitial";
import performanceAnxietyFollowUp from "../../../../../medical/performanceAnxietyFollowUp";
import insomniaInitial from "../../../../../medical/insomnia-initial.js";
import insomniaFollowUpTrial from "../../../../../medical/insomnia-follow-up-trial.js";

import ConsultationQuestion from "./consultationQuestion.jsx";
import VisitProgress from "./visitProgress.jsx";

// import axios from "axios";
import KickClient from "../utils/api";
import { bugsnagClient } from "../../shared/utils/errorHandling";

import Cookies from "js-cookie";
import {
  getConsultAnswersJSON,
  setConsultAnswersJSON,
  getVisitID,
  setVisitID,
  getVisitEmail,
} from "../utils/visitCookies";

import {
  kickRed,
  kickNavy,
  kickBlue,
  kickAmaOrange,
} from "../../shared/styles/baseStyles.js";

import {
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP,
} from "../../shared/sharedConstants.js";
import {
  isConsultationTypeInsomniaFollowUp,
  isConsultationTypeInsomniaInitial,
} from "../../shared/utils/sharedUtils.js";

class ConsultationPerformanceAnxiety extends React.Component {
  constructor(props) {
    super(props);

    // rehydrate from cookies for    refreshes
    const consultAnswers = getConsultAnswersJSON();

    this.state = {
      consultationType: this.props.match.params.consultationType,
      questionId: this.props.match.params.questionId,
      questionError: "",
      consultAnswers: consultAnswers || {},
      refresh: false,
    };
    this.state.questionIndex = Number(this.state.questionId) - 1;
  }

  componentDidUpdate() {
    // sync questionId and questionIndex so child question component refreshes - fixes back bug

    const questionID = Number(this.props.match.params.questionId);
    if (this.state.questionId != questionID) {
      this.setState({ questionId: questionID, questionIndex: questionID - 1 });
    }
  }

  totalQuestionsCount = () => {
    let totalCount = this.consultQuestionnaire().questions.length;

    return totalCount;
  };

  consultQuestionnaire = () => {
    switch (this.state.consultationType) {
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY:
        return performanceAnxietyInitial;
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP:
        return performanceAnxietyFollowUp;

      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA:
        return insomniaInitial;
      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP:
        return insomniaFollowUpTrial;
    }

    return performanceAnxietyInitial;
  };

  isInitialVisit = () => {
    switch (this.state.consultationType) {
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP:
      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP:
        return false;
    }
    return true;
  };

  nextQuestion = () => {
    this.setState({ questionError: "" });
    // store answers in cookies
    setConsultAnswersJSON(this.state.consultAnswers);

    const path = `/visits/questionnaire/${this.state.consultationType}/${
      this.consultQuestionnaire().version
    }/${getVisitID() || ""}`;
    const postData = this.state.consultAnswers;
    // end of questionnaire... go to photoupload
    if (this.state.questionId >= this.consultQuestionnaire().questions.length) {
      // console.log(JSON.stringify(postData));

      KickClient.newAuthenticatedClient()
        .post(path, postData)
        .then((response) => {
          console.log(response);

          // store visit ID
          setVisitID(response.data.data.id);

          // follow-up insomnia visit, just complete
          if (isConsultationTypeInsomniaFollowUp(this.state.consultationType)) {
            this.props.history.push(
              `/visits/${this.state.consultationType}/complete`
            );
          } else if (
            // initial insomnia visit, go to membership description
            isConsultationTypeInsomniaInitial(this.state.consultationType)
          ) {
            this.props.history.push(
              `/visits/${this.state.consultationType}/sleep-membership-description`
            );
          } else {
            // performance anxiety visit, go to select pharmacy
            this.props.history.push(
              `/visits/${this.state.consultationType}/select-pharmacy`
            );
          }
        })
        .catch((error) => {
          bugsnagClient.user = {
            email: getVisitEmail(),
          };

          bugsnagClient.notify(error, {
            beforeSend: function (report) {
              report.metaData = {
                cookies: Cookies.get(),
                localStorage: localStorage,
                visit: { email: getVisitEmail() },
              };
            },
          });

          console.error("error: ", error);

          // bugsnagClient.notify(error);
        });

      // this.props.history.push(
      //   // "/visits/performance-anxiety-consultation/payment"
      //   "/visits/performance-anxiety-consultation/photo-upload/you"
      // );
    } else {
      // Just go to next question...
      let newQuestionId = Number(this.state.questionId) + 1;
      this.setState({
        questionId: newQuestionId,
        questionIndex: newQuestionId - 1,
        questionError: "",
      });

      this.props.history.push(
        `/visits/${this.state.consultationType}/${newQuestionId}`
      );

      window.scrollTo(0, 100);
    }
  };

  validateQuestionAnswers(question, answer) {
    // console.log("question: ", question);
    // console.log("answer: ", answer);

    const topLevelValid = this.validateAnswerCompleted(question.type, answer);

    if (!topLevelValid) {
      this.setState({ questionError: "Please answer the question" });
      return false;
    }

    if (!find(question.choices, "children")) return true;

    switch (question.type) {
      case "checkbox": {
        var checkedAnswers = omit(answer, "question");

        const arrValid = map(keys(checkedAnswers), (key) => {
          if (checkedAnswers[key].checked == false) return null;
          if (!question.choices[key].children) return null;

          // childAnswers should be defined if there's been any activity on child
          if (!checkedAnswers[key].childAnswers) {
            this.setState({
              questionError: "Please answer all the follow-on questions",
            });
            return false;
          }

          return map(checkedAnswers[key].childAnswers, (subQ) => {
            return this.validateAnswerCompleted(subQ.type, subQ);
          });
        });

        if (includes(flatten(arrValid), false)) {
          this.setState({
            questionError: "Please answer all the follow-on questions",
          });
          return false;
        }
        break;
      }
      case "radio": {
        // no child questions, we're done since top level answer is valid
        if (isUndefined(question.choices[answer.selectedIndex].children))
          return true;

        // console.log("question:", question);
        // console.log("answer:", answer);

        const childQuestions = question.choices[answer.selectedIndex].children;
        // console.log("childQ:", childQuestions);
        // none of child questions have been answered - invalid so return false
        if (isUndefined(answer[answer.selectedIndex])) {
          // console.log("answer[answer.selectedIndex] is undefined");
          this.setState({
            questionError: "Please answer all the follow-on questions",
          });
          return false;
        }

        const childAnswers = answer[answer.selectedIndex].childAnswers;
        // console.log("childAnswers", childAnswers);
        // console.log("childAnswers:", childAnswers);
        // if (isUndefined(childAnswers)) {
        //   this.setState({
        //     questionError: "Please answer all the follow-on questions"
        //   });
        //   return false;
        // }

        const arrRadioValid = map(childQuestions, (childQ) => {
          // childAnswers should be defined if there's been any activity on child
          if (isUndefined(childAnswers[childQ.code])) {
            console.error("QCode not found in answer");
            return false;
          }

          return map(childAnswers, (subQ) => {
            return this.validateAnswerCompleted(subQ.type, subQ);
          });
        });

        // console.log("arrRadioValid:", arrRadioValid);

        if (includes(flatten(arrRadioValid), false)) {
          this.setState({
            questionError: "Please answer all the follow-on questions",
          });
          return false;
        }
      }
    }
    return true;
  }

  validateAnswerCompleted(questionType, answer) {
    switch (questionType) {
      case "checkbox": {
        const checkedBox = findKey(answer, (o) => {
          return o.checked == true;
        });

        return !isUndefined(checkedBox);
      }
      case "radio":
      case "bloodpressure-systolic":
      case "bloodpressure-diastolic":
        return !isUndefined(answer.selectedIndex);

      case "text":
      case "textarea": {
        const isValid = answer.value.length > 0;
        return isValid;
      }
    }
  }

  recordAnswer = (questionIndex, answer) => {
    this.setState(
      produce((draft) => {
        draft.consultAnswers[questionIndex] = answer;
      }),
      () => {
        // console.log("NEW State: ", this.state);
      }
    );
    this.setState({ questionError: "", refresh: !this.state.refresh });
  };

  render() {
    const { classes, location, history, match } = this.props;

    return (
      <React.Fragment>
        <VisitProgress
          questionNumber={this.state.questionId}
          totalQuestions={this.totalQuestionsCount()}
        />
        <div
          className={classes.container}
          style={{ backgroundColor: "#3F3F82" }}
        >
          <Card
            className={classes.cardConsultation}
            style={{ backgroundColor: "#3F3F82", boxShadow: "none" }}
          >
            <CardBody style={{ border: "" }}>
              <GridContainer justifyContent="center">
                <GridItem xs={12} sm={12} md={8} noPadding>
                  <ConsultationQuestion
                    location={location}
                    questionIndex={this.state.questionIndex}
                    questionError={this.state.questionError}
                    question={
                      this.consultQuestionnaire().questions[
                        this.state.questionIndex
                      ]
                    }
                    consultAnswers={this.state.consultAnswers}
                    refresh={this.state.refresh}
                    recordAnswer={this.recordAnswer}
                  />

                  <div style={{ color: "red", margin: "20px auto 6px auto" }}>
                    <p style={{ textAlign: "center" }}>
                      {this.state.questionError}
                    </p>
                  </div>

                  <Button
                    onClick={() => {
                      // question never answered
                      if (
                        this.state.consultAnswers[this.state.questionIndex] ==
                        null
                      ) {
                        this.setState({
                          questionError: "Please answer the question",
                        });
                        return;
                      }

                      var validAnswers = this.validateQuestionAnswers(
                        this.consultQuestionnaire().questions[
                          this.state.questionIndex
                        ],
                        this.state.consultAnswers[this.state.questionIndex]
                      );

                      if (!validAnswers) {
                        return;
                      }

                      this.nextQuestion();
                    }}
                    style={{
                      display: "block",

                      backgroundColor: kickRed,
                      margin: "0px auto",
                      width: "300px",
                      fontSize: "18px",
                      fontWeight: "medium",
                      textTransform: "unset",
                    }}
                  >
                    Continue
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </div>
      </React.Fragment>
    );
  }
}

ConsultationPerformanceAnxiety.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(ConsultationPerformanceAnxiety);
